import actionTypes from './formViewer.actionTypes';
import { addErrorMessage, addSuccessMessage, dismissMessage } from '../Common/Components/flashMessage/flashMessage.actions';
import * as FormsApiService from '../Common/Services/FormsApiService';
import { FormViewerActionTakenDisplays, ParticipantStatuses } from './formViewer.constants';
import { isNullOrEmptyGuid } from '../Common/Services/utilities';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';


export const updateFormUnansweredCount = (unansweredCount) => {
  return { type: actionTypes.UPDATE_LAUNCHED_FORM_UNANSWERED_COUNT, data: unansweredCount };
};

export const setFormModified = (answers, allVisibleQuestionsCount) => {
  return { type: actionTypes.SET_LAUNCHED_FORM_MODIFIED, data: { answers, allVisibleQuestionsCount } };
};

export const formInstanceCancelRequested = () => {
  return { type: actionTypes.LAUNCHED_FORM_CANCEL_REQUESTED };
};

export const formInstanceCancelCancelled = () => {
  return { type: actionTypes.LAUNCHED_FORM_CANCEL_CANCELLED };
};

export const setSessionTimeoutExpiring = () => {
  return { type: actionTypes.SET_SESSION_TIMEOUT_EXPIRING };
};

export const clearSessionTimeoutExpiring = () => {
  return { type: actionTypes.CLEAR_SESSION_TIMEOUT_EXPIRING };
};

export const getLaunchedFormByInstanceOrParticipantGuid = (companyId, employeeId, employeeName, instanceGuid, participantGuid, isPublicForm, isReadOnly, createNewParticipantRecord, formTypeId, foreignIdValue, moduleId = null) => {
  return async (dispatch, getState) => {
    dispatch(dismissMessage());

    let useSurveysLabels = getState().formViewer.useSurveysLabels;
    let caption = useSurveysLabels ? "survey" : "form";
    let captionUpper = useSurveysLabels ? "Survey" : "Form";
    dispatch({ type: actionTypes.RESET_LAUNCHED_FORM_STATE });
    dispatch({ type: actionTypes.FETCH_LAUNCHED_FORM_BEGIN, payload: { companyId, employeeId } });

    try {
      let response = {};

      if (participantGuid) {
        response = await FormsApiService.getFormInstanceParticipant(companyId, employeeId, participantGuid, isPublicForm, moduleId);
      }
      else if (instanceGuid && !participantGuid) {
        // if dynamically creating a new participant, set to the magic employeeid for api passthru
        let activeEmployeeId = createNewParticipantRecord ? "X92BC348Z" : employeeId;
        response = await FormsApiService.getFormInstanceParticipantByInstance(companyId, activeEmployeeId, instanceGuid, isPublicForm);
      }
      else if (foreignIdValue && formTypeId && !instanceGuid && !participantGuid) {
        response = await FormsApiService.getFormInstanceParticipantByForeignId(companyId, employeeId, formTypeId, foreignIdValue);
      }

      if (response) {
        let formInstanceDetail = response;
        formInstanceDetail.employeeId = employeeId;
        formInstanceDetail.employeeName = employeeName;
        formInstanceDetail.isPublicForm = isPublicForm;
        formInstanceDetail.allowParticipantGuidCreation = (!isNullOrEmptyGuid(instanceGuid) && isNullOrEmptyGuid(participantGuid));
        formInstanceDetail.foreignId = foreignIdValue;
        dispatch({ type: actionTypes.FETCH_LAUNCHED_FORM_SUCCESS, data: formInstanceDetail });

        if (!isReadOnly) {
          if (formInstanceDetail.statusDescription === "Rescinded") {
            dispatch(addErrorMessage(`This ${caption} was rescinded and can no longer be completed.`, 'Error'));
          }
          else if (formInstanceDetail.isClosed && formInstanceDetail.statusDescription !== "Completed") {
            dispatch(addErrorMessage(`This ${caption} is closed and is no longer available.`, 'Error'));
          }
        }
      }
      else {
        dispatch({ type: actionTypes.FETCH_LAUNCHED_FORM_FAILURE });
        dispatch(addErrorMessage(`Cannot access requested  ${caption}.`, 'Error', `${captionUpper}Details.errorRetrieving${captionUpper}`, `${captionUpper}Details.error`));
      }
    }
    catch (e) {
      if (e && e.request && e.request.status === 302) {
        // if err == 302, the app-shell session token has expired, so popup the session-expiring window
        dispatch({ type: actionTypes.SET_SESSION_TIMEOUT_EXPIRING });
      }
      else {
        dispatch({ type: actionTypes.FETCH_LAUNCHED_FORM_FAILURE });
        dispatch(addErrorMessage(`Cannot access requested ${caption}.`, 'Error', `${captionUpper}Details.errorRetrieving${captionUpper}`, `${captionUpper}Details.error`));
      }
    }
  }
};


export const saveDraftLaunchedForm = (formInstance, displayFormActionView, isAutoSaveDraft, isPublicForm) => {
  return async (dispatch, getState) => {
    let companyId = getState().formViewer.companyId;
    let employeeId = getState().formViewer.employeeId;
    let useSurveysLabels = getState().formViewer.useSurveysLabels;
    let caption = useSurveysLabels ? "survey" : "form";
    let captionUpper = useSurveysLabels ? "Survey" : "Form";

    formInstance.participantStatusId = ParticipantStatuses.InProgress;

    try {
      if (formInstance.allowParticipantGuidCreation && isNullOrEmptyGuid(formInstance.formInstanceParticipantGuid)) {
        formInstance.formInstanceParticipantGuid = uuidv4();
      }

      window.dispatchEvent(new CustomEvent('PctyTalentFormViewerSavingAsDraft', { detail: formInstance }));
      dispatch({ type: actionTypes.SAVE_DRAFT_LAUNCHED_FORM_BEGIN });

      const response = await FormsApiService.saveFormInstanceParticipant(companyId, employeeId, formInstance, isPublicForm);
      if (response) {
        dispatch({ type: actionTypes.SAVE_DRAFT_LAUNCHED_FORM_SUCCESS, data: formInstance });

        // only display messaging if NOT auto-saving
        if (isAutoSaveDraft === false) {
          if (displayFormActionView) {
            dispatch({ type: actionTypes.SET_LAUNCHED_FORM_ACTION_TAKEN_DISPLAY, data: FormViewerActionTakenDisplays.SaveAsDraft });
          }
          else {
            dispatch(addSuccessMessage(`${captionUpper} saved as draft.`, "Success", `${captionUpper}Details.errorSavingDraft${captionUpper}`, `${captionUpper}Details.success`));
          }

          var evt = new CustomEvent('PctyTalentFormViewerSavedAsDraft', { detail: formInstance });
          window.dispatchEvent(evt);
        }
        else {
          // raise the auto-save event!
          var evt = new CustomEvent('PctyTalentFormViewerAutoSavedAsDraft', { detail: formInstance });
          window.dispatchEvent(evt);
        }
      }
      else {
        dispatch({ type: actionTypes.SAVE_DRAFT_LAUNCHED_FORM_FAILURE });
        dispatch(addErrorMessage(`Error saving ${caption} draft.`, 'Error'));
      }
    }
    catch (e) {
      if (e && e.request && e.request.status === 302) {
        // if err == 302, the app-shell session token has expired, so popup the session-expiring window
        dispatch({ type: actionTypes.SET_SESSION_TIMEOUT_EXPIRING });
      }
      else {
        dispatch({ type: actionTypes.SAVE_DRAFT_LAUNCHED_FORM_FAILURE });
        dispatch(addErrorMessage(`Error saving ${caption} draft.`, 'Error', `${captionUpper}Details.errorSavingDraft${captionUpper}`, `${captionUpper}Details.error`));
      }
    }
  }
};


export const completeLaunchedForm = (formInstance, displayFormActionView, isPublicForm) => {
  return async (dispatch, getState) => {
    let companyId = getState().formViewer.companyId;
    let employeeId = getState().formViewer.employeeId;
    let useSurveysLabels = getState().formViewer.useSurveysLabels;
    let caption = useSurveysLabels ? "survey" : "form";
    let captionUpper = useSurveysLabels ? "Survey" : "Form";

    formInstance.completedDate = moment();
    formInstance.participantStatusId = ParticipantStatuses.Completed;

    try {
      if (formInstance.allowParticipantGuidCreation && isNullOrEmptyGuid(formInstance.formInstanceParticipantGuid)) {
        formInstance.formInstanceParticipantGuid = uuidv4();
      }

      window.dispatchEvent(new CustomEvent('PctyTalentFormViewerCompleting', { detail: formInstance }));

      dispatch({ type: actionTypes.COMPLETE_LAUNCHED_FORM_BEGIN });

      const response = await FormsApiService.saveFormInstanceParticipant(companyId, employeeId, formInstance, isPublicForm);
      if (response) {
        if (response.id === 0) {
          dispatch({ type: actionTypes.COMPLETE_LAUNCHED_FORM_FAILURE_NOT_AVAILABLE });
        }
        else {
          dispatch({ type: actionTypes.COMPLETE_LAUNCHED_FORM_SUCCESS, data: formInstance });

          if (displayFormActionView) {
            dispatch({ type: actionTypes.SET_LAUNCHED_FORM_ACTION_TAKEN_DISPLAY, data: FormViewerActionTakenDisplays.Completed });
          }
          else {
            dispatch(addSuccessMessage(`${captionUpper} completed.`, "Success", `${captionUpper}Details.successCompleting${captionUpper}`, `${captionUpper}Details.success`));
          }
        }

        var evt = new CustomEvent('PctyTalentFormViewerCompleted', { detail: formInstance });
        window.dispatchEvent(evt);
      }
      else {
        dispatch({ type: actionTypes.COMPLETE_LAUNCHED_FORM_FAILURE });
        dispatch(addErrorMessage(`Error completing ${caption}.`, 'Error', `${captionUpper}Details.errorCompleting${captionUpper}`, `${captionUpper}Details.error`));
      }
    }
    catch (e) {
      if (e && e.request && e.request.status === 302) {
        // if err == 302, the app-shell session token has expired, so popup the session-expiring window
        dispatch({ type: actionTypes.SET_SESSION_TIMEOUT_EXPIRING });
      }
      else {
        dispatch({ type: actionTypes.COMPLETE_LAUNCHED_FORM_FAILURE });
        dispatch(addErrorMessage(`Error completing ${caption}.`, 'Error', `${captionUpper}Details.errorCompleting${captionUpper}`, `${captionUpper}Details.error`));
      }
    }
  }
};

export const declineLaunchedForm = (formInstance, displayFormActionView, isPublicForm) => {
  return async (dispatch, getState) => {
    let companyId = getState().formViewer.companyId;
    let employeeId = getState().formViewer.employeeId;
    let useSurveysLabels = getState().formViewer.useSurveysLabels;
    let caption = useSurveysLabels ? "survey" : "form";
    let captionUpper = useSurveysLabels ? "Survey" : "Form";

    try {
      if (isNullOrEmptyGuid(formInstance.formInstanceParticipantGuid)) {
        dispatch(addSuccessMessage(`${captionUpper} opted out.`, "Success", `${captionUpper}Details.successOptingOut${captionUpper}`, `${captionUpper}Details.success`));
        dispatch({ type: actionTypes.RESET_LAUNCHED_FORM_STATE });

        var evt = new CustomEvent('PctyTalentFormViewerOptedOut', { detail: formInstance });
        window.dispatchEvent(evt);
      }

      dispatch({ type: actionTypes.DECLINE_LAUNCHED_FORM_BEGIN });

      const response = await FormsApiService.declineFormInstanceParticipant(companyId, employeeId, formInstance.formInstanceParticipantGuid, formInstance, isPublicForm);
      if (response) {
        dispatch({ type: actionTypes.DECLINE_LAUNCHED_FORM_SUCCESS });

        if (displayFormActionView) {
          dispatch({ type: actionTypes.SET_LAUNCHED_FORM_ACTION_TAKEN_DISPLAY, data: FormViewerActionTakenDisplays.OptedOut });
        }
        else {
          dispatch(addSuccessMessage(`${captionUpper} opted out.`, "Success", `${captionUpper}Details.successOptingOut${captionUpper}`, `${captionUpper}Details.success`));
          dispatch({ type: actionTypes.RESET_LAUNCHED_FORM_STATE });
        }

        var evt = new CustomEvent('PctyTalentFormViewerOptedOut', { detail: formInstance });
        window.dispatchEvent(evt);
      }
      else {
        dispatch({ type: actionTypes.DECLINE_LAUNCHED_FORM_FAILURE });
        dispatch(addErrorMessage(`Error opting out of ${caption}.`, 'Error', `${captionUpper}Details.errorOptingOut${captionUpper}`, `${captionUpper}Details.error`));
      }
    }
    catch (e) {
      if (e && e.request && e.request.status === 302) {
        // if err == 302, the app-shell session token has expired, so popup the session-expiring window
        dispatch({ type: actionTypes.SET_SESSION_TIMEOUT_EXPIRING });
      }
      else {
        dispatch({ type: actionTypes.DECLINE_LAUNCHED_FORM_FAILURE });
        dispatch(addErrorMessage(`Error opting out of ${caption}.`, 'Error', `${captionUpper}Details.errorOptingOut${captionUpper}`, `${captionUpper}Details.error`));
      }
    }
  }
};


export const saveDraftWithPostProcessing = (formInstance, isPublicForm) => {
  return async (dispatch, getState) => {
    let companyId = getState().formViewer.companyId;
    let employeeId = getState().formViewer.employeeId;
    let useSurveysLabels = getState().formViewer.useSurveysLabels;
    let caption = useSurveysLabels ? "survey" : "form";
    let captionUpper = useSurveysLabels ? "Survey" : "Form";

    formInstance.participantStatusId = ParticipantStatuses.InProgress;

    try {
      if (formInstance.allowParticipantGuidCreation && isNullOrEmptyGuid(formInstance.formInstanceParticipantGuid)) {
        formInstance.formInstanceParticipantGuid = uuidv4();
      }

      dispatch({ type: actionTypes.SAVE_DRAFT_LAUNCHED_FORM_BEGIN });
      
      window.dispatchEvent(new CustomEvent('PctyTalentFormViewerStartPreProcessingActionEvent', { detail: { formInstance: formInstance, isPublicForm: isPublicForm } }));

      const response = await FormsApiService.saveFormInstanceParticipant(companyId, employeeId, formInstance, isPublicForm);
      if (response) {
        dispatch({ type: actionTypes.SAVE_DRAFT_LAUNCHED_FORM_SUCCESS, data: formInstance });

        // EV-1363 - Send post processing event
        window.dispatchEvent(new CustomEvent('PctyTalentFormViewerStartPostProcessingEvent', { detail: { formInstance: formInstance, isPublicForm: isPublicForm } }));
      }
      else {
        dispatch({ type: actionTypes.SAVE_DRAFT_LAUNCHED_FORM_FAILURE });
        dispatch(addErrorMessage(`There was a problem saving the ${caption}. Please try again.`, 'Error'));
      }
    }
    catch (e) {
      if (e && e.request && e.request.status === 302) {
        // if err == 302, the app-shell session token has expired, so popup the session-expiring window
        dispatch({ type: actionTypes.SET_SESSION_TIMEOUT_EXPIRING });
      }
      else {
        dispatch({ type: actionTypes.SAVE_DRAFT_LAUNCHED_FORM_FAILURE });
        dispatch(addErrorMessage(`Error saving ${caption} draft.`, 'Error', `${captionUpper}Details.errorSavingDraft${captionUpper}`, `${captionUpper}Details.error`));
      }
    }
  }
};

export const completeLaunchedFormAfterPostProcessing = (formInstance, isPublicForm) => {
  return async (dispatch, getState) => {
    let companyId = getState().formViewer.companyId;
    let employeeId = getState().formViewer.employeeId;
    let useSurveysLabels = getState().formViewer.useSurveysLabels;
    let caption = useSurveysLabels ? "survey" : "form";
    let captionUpper = useSurveysLabels ? "Survey" : "Form";
    

    formInstance.completedDate = moment();
    formInstance.participantStatusId = ParticipantStatuses.Completed;

    let saveSuccessful = false;

    try {
      if (formInstance.allowParticipantGuidCreation && isNullOrEmptyGuid(formInstance.formInstanceParticipantGuid)) {
        formInstance.formInstanceParticipantGuid = uuidv4();
      }

      dispatch({ type: actionTypes.COMPLETE_LAUNCHED_FORM_BEGIN });

      const response = await FormsApiService.saveFormInstanceParticipant(companyId, employeeId, formInstance, isPublicForm);
      if (response) {
        if (response.id === 0) {
          dispatch({ type: actionTypes.COMPLETE_LAUNCHED_FORM_FAILURE_NOT_AVAILABLE });
        } else {
          dispatch({ type: actionTypes.COMPLETE_LAUNCHED_FORM_SUCCESS, data: formInstance });

          // For mobile, this triggers the hiding of the Form Viewer which is replaced with the survey successfully
          // completed screen. This is vital as we do not re-route a mobile user away from the original Form Viewer automatically
          // and need to stop them from attempting to complete the same survey twice.
          dispatch({ type: actionTypes.SET_LAUNCHED_FORM_ACTION_TAKEN_DISPLAY, data: FormViewerActionTakenDisplays.Completed });

          saveSuccessful = true;
        }
      }
      else {
        dispatch({ type: actionTypes.COMPLETE_LAUNCHED_FORM_FAILURE });
        dispatch(addErrorMessage(`Error completing ${caption}.`, 'Error', `${captionUpper}Details.errorCompleting${captionUpper}`, `${captionUpper}Details.error`));
      }

    }
    catch (e) {
      if (e && e.request && e.request.status === 302) {
        // if err == 302, the app-shell session token has expired, so popup the session-expiring window
        dispatch({ type: actionTypes.SET_SESSION_TIMEOUT_EXPIRING });
      }
      else {
        dispatch({ type: actionTypes.COMPLETE_LAUNCHED_FORM_FAILURE });
        dispatch(addErrorMessage(`Error completing ${caption}.`, 'Error', `${captionUpper}Details.errorCompleting${captionUpper}`, `${captionUpper}Details.error`));
      }
    }

    // Always send completed event
    var evt = new CustomEvent('PctyTalentFormViewerFormCompleteAfterPostProcessingCompleted', { detail: { saveSuccessful: saveSuccessful } });
    window.dispatchEvent(evt);
  }
};


export const resetState = () => {
  return { type: actionTypes.RESET_LAUNCHED_FORM_STATE };
};
